import "./Style.scss";
import CategoryManagement from "./CategoryManagement";
import Detail from "./Detail";

export { CategoryManagement, Detail };
